import React, { useEffect } from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  formControl: {
    width: '70%',
    padding: '20px 0',
    textAlign: 'left',
    '& >*': {
      width: '100%'
    },
    '& legend': {
      position: 'relative',
      top: 20,
      marginBottom: 10
    },
    '& label': {
      fontSize: 14
    },
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      padding: '10px 0'
    }
  }

}));


export const RadioInput = ({ options, onChange, label, defaultValue, name, value, ...rest }) => {
  const classes = useStyles();
  useEffect(() => {
    if (defaultValue) {
      onChange({ target: { value: defaultValue, name: name } })
    }
  }, [])

  return (
    <FormControl {...rest} component="fieldset" className={classes.formControl}>
      <FormLabel component="legend">{label}</FormLabel>
      <RadioGroup defaultValue={defaultValue} name={name} {...rest} value={value} onChange={onChange}>
        {options && options.length && options.map((option, index) => {
          return (<FormControlLabel key={index} value={option.value} control={<Radio />} label={option.key} />)
        })}
      </RadioGroup>
    </FormControl>
  )
}
